import { logoutUser, getLoggedInUser, getDeviceKey, CSRF_TOKEN_HEADER_KEY, getCsrfToken, updateAccessTokenExpirationTime, updateCsrfToken, isAccessTokenExpired } from 'services/AuthService';
import axios from 'axios';
import config from 'config';

export function sendAsyncRequest(uri, method, data, onSuccessCallback, onFailureCallback){
  axios({
    method: method,
    url: url(uri),
    data: data,
    withCredentials: true
  }).then(function (response) {
    onSuccessCallback(response);
  }).catch(function (error) {
    onFailureCallback(error);
  });
}

function asyncAuthRequest(uri, method, data, onSuccessCallback, onFailureCallback, responseType, onFinallyCallback){
  if (isAccessTokenExpired()) {
    refreshToken(uri, method, data, onSuccessCallback, onFailureCallback, responseType, onFinallyCallback);
  } else {
  axios({
    method: method,
    url: url(uri),
    data: data,
    responseType: responseType,
    headers: { [CSRF_TOKEN_HEADER_KEY]: getCsrfToken() },
    withCredentials: true,
  })
    .then(function (response) {
      onSuccessCallback(response);
    })
    .catch(function (error) {
      if (error.response && error.response.status === 401) {
        refreshToken(uri, method, data, onSuccessCallback, onFailureCallback, responseType, onFinallyCallback);
      } else {
        if (typeof onFailureCallback === 'function')
          onFailureCallback(error.response || error);
        else
          console.log(error.response);
      }
    })
    .finally(() => {
      if (typeof onFinallyCallback === 'function') onFinallyCallback();
    });
  }
}

export function sendAuthenticatedAsyncRequest(uri, method, data, onSuccessCallback, onFailureCallback){
  asyncAuthRequest(uri, method, data, onSuccessCallback, onFailureCallback, null, null);
}

export function sendAuthenticatedAsyncRequestWithResponseType(uri, method, data, onSuccessCallback, onFailureCallback, responseType){
  asyncAuthRequest(uri, method, data, onSuccessCallback, onFailureCallback, responseType, null);
}

export function sendAuthenticatedAsyncRequestWithFinallyCallback(uri, method, data, onSuccessCallback, onFailureCallback, onFinallyCallback){
  asyncAuthRequest(uri, method, data, onSuccessCallback, onFailureCallback, null, onFinallyCallback);
}

function refreshToken(uri, method, data, onSuccessCallback, onFailureCallback, responseType, onFinallyCallback) {
  const user = getLoggedInUser();
  const deviceId = getDeviceKey();

  axios({
    method: 'POST',
    url: url('/login/refresh-token'),
    data: JSON.stringify({
      email: user?.email,
      deviceId: deviceId
    }),
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
  })
    .then(function (response) {
      const { currentTimeMillis, idTokenDurationSecs, csrfToken } = response.data;
      updateAccessTokenExpirationTime(currentTimeMillis, idTokenDurationSecs);
      if (csrfToken) {
        updateCsrfToken(csrfToken);
      }
      asyncAuthRequest(uri, method, data, onSuccessCallback, onFailureCallback, responseType, onFinallyCallback);
    })
    .catch(function (error) {
      if (!error.response || error.response.status === 401) {
        logoutUser();
      } else {
        if (typeof onFailureCallback === 'function')
          onFailureCallback(error.response || error);
        else
          console.log(error.response);
      }
    });
}

const url = (uri) => `${config.apiRoot}${uri}`;
